module.exports = __webpack_public_path__ + "static/img/lun_2.1d6fc2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lun_2.jpg
// module id = O+GO
// module chunks = 1